<div class="row filter-collapse" #filterCollapse>
    <div class="col-12">
        <div class="row">
            <div class="form-group col-12 col-md-6">
                <label for="situacoes" class="col-form-label">Situações</label>
                <sgt-regiao-situacao-multiselect
                    [(situacoes)]="filter.situacoes"
                    (situacoesChange)="isFilterDirty = true">
                </sgt-regiao-situacao-multiselect>
            </div>
        </div>
        <div class="row">
            <div class="form-group col-12 col-md-6" *ngIf="!isRepresentante">
                <label for="representante" class="col-form-label">Representante</label>
                <sgt-typeahead-representante [(ngModel)]="filter.representante" name="representante" id="representante"
                    #representante="ngModel" [ngControl]="representante"
                    (typeaheadChange)="onTypeaheadChangeRepresentante($event)">
                </sgt-typeahead-representante>                                                                  
            </div>
            <div class="form-group col-12 col-md-6">
                    <label for="estado" class="col-form-label">Estado</label>
                    <select class="form-control" name="estado" id="estado"
                    [ngModel]="filter.idEstado || ''" (ngModelChange)="filter.idEstado = $event ? $event : null; isFilterDirty = true;">
                    <option value="">Selecione o estado...</option>
                    <option *ngFor="let estado of estados" [ngValue]="estado.id">{{estado.nome}}</option>
                </select>                 
            </div>                        
        </div>       
    </div>
</div>